import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import RatingStars from '../helpers/RatingStars'

export default function ScubaTribeButton({ rating, url, numberOfReviews }) {
  return (
    <Fragment>
      <div className='title'>
        <FormattedMessage id='scuba_tribe_rating' defaultMessage='ScubaTribe Diver Rating' />
      </div>
      <div className='rating-wrap tripadvisor-rating-wrap'>
        <img src={`${window.staticPath}travel_dist/images/scuba-tribe.png`} alt='Scuba tribe logo' />
        <RatingStars rating={rating} />
        <a rel='nofollow' href={url} target='_blank' className='rating-count'>
          <FormattedMessage id='reviews_plural'
            values={{ qty: numberOfReviews }}
            defaultMessage='{qty, plural, one {# review} other {# reviews}}' />
        </a>
      </div>
    </Fragment>)
}
